import {
  Box,
  Grid,
  Typography,
  TextField,
  Dialog,
  DialogContent,
  useTheme,
  useMediaQuery,
  DialogActions,
  MenuItem,
  Autocomplete,
  Checkbox,
  Link,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import styles from "../InternalTracker.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import { IoIosArrowRoundForward } from "react-icons/io";
import { useFormik } from "formik";
import {
  addSkill,
  allSkill,
  resetAddedSkill,
} from "../../../redux/common/skillSlice";
import { useDispatch, useSelector } from "react-redux";
import { IoBookOutline } from "react-icons/io5";
import { addPreviousExperienceValue } from "../../../redux/internalCandidateStaticValue/internalCandidateStaticValue";
import { IoIosAdd } from "react-icons/io";
import { PiMapPinSimpleLineLight } from "react-icons/pi";
import { PiBuildingOfficeLight } from "react-icons/pi";
import { PiUserLight } from "react-icons/pi";
import profile from "../../../assets/images/oversight-concept-illustration.png";
import { FixedSizeList } from "react-window";

const fieldStyle = {
  width: "100%",
  "& .MuiInputBase-root": {
    paddingLeft: "30px", // Adjust padding to make space for the icon
  },
  "& .MuiInputLabel-root": {
    left: "35px",
    fontSize: "14px ", // Adjust label position to align with input text
  },
  "& .MuiInputBase-input": {
    paddingBottom: "7px", // Add padding to the input text itself to make space for the icon
  },
  "& .MuiInputLabel-shrink": {
    left: "35px",
    fontSize: "14px ", // Adjust label position when it shrinks
  },
  padding: "7px",
};

const renderVirtualizedList = React.forwardRef(function ListboxComponent(
  props,
  ref
) {
  const { children, ...rest } = props;

  return (
    <div ref={ref} {...rest}>
      <FixedSizeList
        height={300} // Adjust dropdown height
        width="100%"
        itemSize={46} // Height of each item
        itemCount={children.length}
      >
        {({ index, style }) =>
          React.cloneElement(children[index], {
            style: { ...style, top: `${style.top}px` },
            onMouseDown: (event) => {
              // Prevent closing on click
              event.preventDefault();
            },
          })
        }
      </FixedSizeList>
    </div>
  );
});

const AddConsultantResume = ({ setMenuName, setMenuId }) => {
  const [skilldata, setSkilldata] = useState([]);
  const [primarySkillIds, setPrimarySkillIds] = useState([]);
  const [secondarySkillIds, setSecondarySkillIds] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const [inputText, setInputText] = useState("");
  const [inputTextSecondary, setInputTextSecondary] = useState("");
  const [whichAdd, setWhichAdd] = useState("");
  const [isEnter, setIsEnter] = useState(false);

  const dispatch = useDispatch();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [openManage, setOpenManage] = useState(false);
  const location = useLocation();

  const skillData = useSelector((state) => state.skill.data);
  const addedSkill = useSelector((state) => state.skill.addedSkill);
  const educationData = useSelector(
    (state) => state.internalCandidateStaticValue.educationData
  );

  const [data, setData] = useState(
    location.state ||
      JSON.parse(localStorage.getItem("internalTrackerCandidateAddOrUpdate"))
  );

  useEffect(() => {
    if (location.state) {
      localStorage.setItem(
        "internalTrackerCandidateAddOrUpdate",
        JSON.stringify(location.state)
      );
      setData(location.state);
    }
  }, [location.state]);

  const [formFields, setFormFields] = useState([
    {
      role: "",
      company: "",
      industry_of_the_company: "",
      duration_from: "",
      duration_to: "",
      summary_of_work: "",
    },
  ]);

  const peviousExperienceData = useSelector(
    (state) => state.internalCandidateStaticValue.peviousExperienceData
  );
  const formik = useFormik({
    initialValues: {
      // time_zone: row?.time_zone || peviousExperienceData?.time_zone || null,

      skills: data?.row?.skills || peviousExperienceData?.skills || [],
      // passing_year: row?.passing_year || peviousExperienceData?.passing_year || null,
      secondary_skills:
        data?.row?.secondary_skills ||
        peviousExperienceData?.secondary_skills ||
        [],
      previous_experience: null,
    },

    onSubmit: (values) => {
      dispatch(addPreviousExperienceValue(values));
      setMenuName("Official Refference");
      setMenuId(2);
    },
  });

  const handleManageClickOpen = () => {
    if (
      formik?.values?.skills !== null &&
      formik?.values?.skills !== "" &&
      formik?.values?.secondary_skills !== null &&
      formik?.values?.secondary_skills !== ""
    ) {
      dispatch(addPreviousExperienceValue(formik?.values));
      setMenuName("Official Refference");
      setMenuId(2);
    } else {
      setOpenManage(true);
    }
  };

  const handleManageClose = () => {
    setOpenManage(false);
  };

  const mapSkillsToIds = (skillsList, allSkillsMap) => {
    const skillIds = [];
    const missingSkills = [];
    skillsList?.forEach((skill) => {
      const skillLower = skill.toLowerCase();
      if (allSkillsMap[skillLower]) {
        skillIds?.push(allSkillsMap[skillLower]);
      } else {
        missingSkills?.push(skill);
      }
    });

    return { skillIds, missingSkills };
  };

  useEffect(() => {
    if (educationData || peviousExperienceData || data) {
      if (
        (peviousExperienceData === undefined ||
          peviousExperienceData === null ||
          peviousExperienceData === "") &&
        (educationData === undefined ||
          educationData === null ||
          educationData === "")
      ) {
        if (data?.types === "view_update") {
          setFormFields(JSON.parse(data?.row?.previous_experience));
        }
      } else if (
        peviousExperienceData === undefined ||
        peviousExperienceData === null ||
        peviousExperienceData === ""
      ) {
        setFormFields(educationData?.companies);
      } else if (peviousExperienceData) {
        setFormFields(peviousExperienceData?.previous_experience);
      }
    }
  }, [educationData, peviousExperienceData, data]);

  useEffect(() => {
    formik.setFieldValue("previous_experience", formFields || "");
  }, [formFields]);

  const handleAddFields = () => {
    setFormFields([
      ...formFields,
      {
        role: "",
        company: "",
        industry_of_the_company: "",
        duration_to: "",
        duration_from: "",
        summary_of_work: "",
      },
    ]);
  };

  const handleInputChange = (index, event) => {
    const { name, value } = event.target;

    const values = [...formFields];
    values[index] = {
      ...values[index],
      [name]: name === "summary_of_work" ? [value] : value,
    };

    setFormFields(values);
  };

  const autoResize = (textarea) => {
    if (textarea) {
      textarea.style.height = "auto"; // Reset the height
      textarea.style.height = `${textarea.scrollHeight}px`; // Set it to match content
    }
  };

  useEffect(() => {
    dispatch(allSkill());
  }, []);

  useEffect(() => {
    if (skillData?.locations?.length > 0) {
      setSkilldata(skillData);
    }
  }, [skillData]);

  useEffect(() => {
    if (
      peviousExperienceData?.skills === undefined ||
      peviousExperienceData?.skills === null ||
      peviousExperienceData?.skills === ""
    ) {
      if (primarySkillIds?.length > 0) {
        formik.setFieldValue("skills", primarySkillIds || []);
      }
    }
  }, [primarySkillIds, peviousExperienceData]);

  useEffect(() => {
    if (
      peviousExperienceData?.secondary_skills === undefined ||
      peviousExperienceData?.secondary_skills === null ||
      peviousExperienceData?.secondary_skills === ""
    ) {
      if (secondarySkillIds?.length > 0) {
        formik.setFieldValue("secondary_skills", secondarySkillIds || []);
      }
    }
  }, [secondarySkillIds, peviousExperienceData]);

  useEffect(() => {
    if (!educationData || !skillData) return;
    if (isEnter === false) {
      const allSkillsMap = skillData?.locations?.reduce((acc, skill) => {
        acc[skill?.name?.toLowerCase()] = skill?.id;
        return acc;
      }, {});

      const primary = mapSkillsToIds(
        educationData?.skills?.primary_skills || [],
        allSkillsMap
      );
      const secondary = mapSkillsToIds(
        educationData?.skills?.secondary_skills || [],
        allSkillsMap
      );

      setPrimarySkillIds(primary?.skillIds);
      // setMissingPrimarySkills(primary?.missingSkills);
      setSecondarySkillIds(secondary?.skillIds);
      // setMissingSecondarySkills(secondary?.missingSkills);

      const missingSkills = [
        ...primary?.missingSkills,
        ...secondary?.missingSkills,
      ];
      if (missingSkills?.length > 0) {
        Promise.all(
          missingSkills?.map((skill) => dispatch(addSkill({ name: skill })))
        )
          .then(async () => {
            // Step 4: Fetch updated skills after all new skills are added
            const updatedSkills = await dispatch(allSkill()).unwrap();
            const updatedSkillsMap = updatedSkills?.reduce((acc, skill) => {
              acc[skill?.name.toLowerCase()] = skill?.id;
              return acc;
            }, {});

            // Step 5: Remap primary and secondary skills to IDs
            const updatedPrimary = mapSkillsToIds(
              educationData.primary_skills || [],
              updatedSkillsMap
            );
            const updatedSecondary = mapSkillsToIds(
              educationData.secondary_skills || [],
              updatedSkillsMap
            );

            setPrimarySkillIds(updatedPrimary?.skillIds);
            setSecondarySkillIds(updatedSecondary?.skillIds);
          })
          .catch((error) => {
            console.error("Error adding skills:", error);
          });
      }
    }
  }, [educationData, skillData, dispatch]);

  const handleToggle = () => {
    setShowMore(!showMore);
  };
  useEffect(() => {
    if (primarySkillIds?.length > 0) {
      formik.setFieldValue("skills", primarySkillIds || []);
    }
  }, [primarySkillIds]);

  useEffect(() => {
    if (addedSkill?.location?.id) {
      const skillId = addedSkill?.location?.id;
      const currentSkills = formik.values.skills || [];
      const currentSecondarySkill = formik.values.secondary_skills || [];

      if (!currentSkills.includes(skillId) && whichAdd === "first") {
        formik.setFieldValue("skills", [...currentSkills, skillId]);
        setInputText("");
        dispatch(resetAddedSkill());
      }

      if (!currentSecondarySkill.includes(skillId) && whichAdd === "second") {
        formik.setFieldValue("secondary_skills", [
          ...currentSecondarySkill,
          skillId,
        ]);
        setInputTextSecondary("");
        dispatch(resetAddedSkill());
      }
    }
  }, [addedSkill, formik, dispatch, whichAdd]);

  const handleAddSkill = useCallback(async () => {
    if (inputText.trim()) {
      const newSkill = inputText.trim();
      const isExistingSkill = skillData?.locations?.some(
        (skl) => skl.name.toLowerCase() === newSkill.toLowerCase()
      );

      if (!isExistingSkill) {
        setWhichAdd("first");
        setIsEnter(true);
        await dispatch(addSkill({ name: newSkill })); // Add new skill
        dispatch(allSkill()); // Refresh skills
      }
    }
  }, [inputText, skillData, dispatch]);

  const handleAddSkillSecondary = useCallback(async () => {
    if (inputTextSecondary.trim()) {
      const newSkill = inputTextSecondary.trim();
      const isExistingSkill = skillData?.locations?.some(
        (skl) => skl.name.toLowerCase() === newSkill.toLowerCase()
      );

      if (!isExistingSkill) {
        setWhichAdd("second");
        setIsEnter(true);
        await dispatch(addSkill({ name: newSkill })); // Add new skill
        dispatch(allSkill()); // Refresh skills
      }
    }
  }, [inputTextSecondary, skillData, dispatch]);

  const handleClearAll = () => {
    formik.setFieldValue("skills", []); // Clear Formik field
    setInputText(""); // Clear input text

    // ✅ Reset addedSkill to prevent it from reappearing
    dispatch(resetAddedSkill());
  };

  const handleClearAllSecondarySkill = () => {
    formik.setFieldValue("secondary_skills", []); // Clear Formik field
    setInputTextSecondary(""); // Clear input text

    // ✅ Reset addedSkill to prevent it from reappearing
    dispatch(resetAddedSkill());
  };

  return (
    <>
      <Box
        className={styles.candidate_structure}
        sx={{ margin: "0 14px 20px" }}
      >
        <form onSubmit={formik.handleSubmit}>
          <Grid container className={styles.candidate_field_section}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              sx={{ marginTop: "10px", padding: "0px 10px 10px" }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  position: "relative",
                }}
              >
                <Box className={styles.icon_style} style={{ left: "7px" }}>
                  <IoBookOutline style={{ fontSize: "22px" }} />
                </Box>

                <Autocomplete
                  multiple
                  id="autocomplete-multi-select"
                  options={skillData?.locations || []}
                  disableCloseOnSelect
                  value={
                    skillData?.locations?.filter((skl) =>
                      formik.values.skills?.includes(skl.id)
                    ) || []
                  }
                  onChange={(event, value) => {
                    const selectedLocations = value?.map((skl) => skl?.id);
                    formik.setFieldValue("skills", selectedLocations);

                    // ✅ Reset addedSkill when manually removing skills
                    if (selectedLocations.length === 0) {
                      handleClearAll(); // Call clear all method
                    } else {
                      dispatch(resetAddedSkill());
                    }
                  }}
                  onBlur={formik.handleBlur}
                  getOptionLabel={(option) => option?.name || ""}
                  inputValue={inputText}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason !== "reset") {
                      setInputText(newInputValue);
                    }
                  }}
                  renderOption={(props, option, { selected }) => (
                    <MenuItem {...props}>
                      <Checkbox
                        checked={selected}
                        sx={{ marginRight: 0, marginLeft: 0 }}
                      />
                      <span>{option?.name}</span>
                    </MenuItem>
                  )}
                  ListboxComponent={renderVirtualizedList} // Use virtualized list
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Skills (Optional)"
                      variant="standard"
                      size="small"
                      name="skills"
                      sx={fieldStyle}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleAddSkill();
                        }
                      }}
                    />
                  )}
                  sx={{ backgroundColor: "#fff", width: "100%" }}
                />
              </Box>
              {formik.touched.skills && formik.errors.skills ? (
                <div className={styles.error}>{formik.errors.skills}</div>
              ) : null}
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              sx={{ marginTop: "10px", padding: "0px 10px 10px" }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  position: "relative",
                }}
              >
                <Box className={styles.icon_style} style={{ left: "7px" }}>
                  <IoBookOutline style={{ fontSize: "22px" }} />
                </Box>

                {/* <Autocomplete
                  multiple
                  id="autocomplete-multi-select"
                  options={skilldata?.locations || []}
                  disableCloseOnSelect
                  value={
                    skilldata?.locations?.filter((skl) =>
                      formik.values.secondary_skills?.includes(skl.id)
                    ) || []
                  }
                  onChange={(event, value) => {
                    const selectedLocations = value?.map((skl) => skl?.id);
                    formik.setFieldValue("secondary_skills", selectedLocations);
                  }}
                  onBlur={formik.handleBlur}
                  getOptionLabel={(option) => option?.name || ""}
                  renderOption={(props, option, { selected }) => (
                    <MenuItem {...props}>
                      <Checkbox
                        checked={selected}
                        sx={{ marginRight: 0, marginLeft: 0 }}
                      />
                      <span>{option?.name}</span>{" "}
                    </MenuItem>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Secondary Skills (Optional)"
                      variant="standard"
                      size="small"
                      name="secondary_skills"
                      sx={fieldStyle}
                    />
                  )}
                  sx={{ backgroundColor: "#fff", width: "100%" }}
                /> */}

                <Autocomplete
                  multiple
                  id="autocomplete-multi-select"
                  options={skillData?.locations || []}
                  disableCloseOnSelect
                  value={
                    skillData?.locations?.filter((skl) =>
                      formik.values.secondary_skills?.includes(skl.id)
                    ) || []
                  }
                  onChange={(event, value) => {
                    const selectedLocations = value?.map((skl) => skl?.id);
                    formik.setFieldValue("secondary_skills", selectedLocations);

                    // ✅ Reset addedSkill when manually removing skills
                    if (selectedLocations.length === 0) {
                      handleClearAllSecondarySkill(); // Call clear all method
                    } else {
                      dispatch(resetAddedSkill());
                    }
                  }}
                  onBlur={formik.handleBlur}
                  getOptionLabel={(option) => option?.name || ""}
                  inputValue={inputTextSecondary}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason !== "reset") {
                      setInputTextSecondary(newInputValue);
                    }
                  }}
                  renderOption={(props, option, { selected }) => (
                    <MenuItem {...props}>
                      <Checkbox
                        checked={selected}
                        sx={{ marginRight: 0, marginLeft: 0 }}
                      />
                      <span>{option?.name}</span>
                    </MenuItem>
                  )}
                  ListboxComponent={renderVirtualizedList} // Use virtualized list
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Secondary Skills (Optional)"
                      variant="standard"
                      size="small"
                      name="secondary_skills"
                      sx={fieldStyle}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleAddSkillSecondary();
                        }
                      }}
                    />
                  )}
                  sx={{ backgroundColor: "#fff", width: "100%" }}
                />
              </Box>
              {formik.touched.secondary_skills &&
              formik.errors.secondary_skills ? (
                <div className={styles.error}>
                  {formik.errors.secondary_skills}
                </div>
              ) : null}
            </Grid>
          </Grid>
        </form>
        {formFields?.map((field, index) => (
          <form onSubmit={(e) => e.preventDefault()} key={index}>
            <Grid
              container
              className={styles.candidate_field_section}
              sx={{ backgroundColor: "#fff" }}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiUserLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Role"
                  variant="standard"
                  name="role"
                  sx={fieldStyle}
                  value={field.role}
                  onChange={(event) => handleInputChange(index, event)}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box
                  className={styles.icon_style}
                  sx={{ transform: "translateY(-50%) !important" }}
                >
                  <PiBuildingOfficeLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Organization"
                  variant="standard"
                  type="text"
                  name="company"
                  sx={fieldStyle}
                  value={field.company}
                  onChange={(event) => handleInputChange(index, event)}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiMapPinSimpleLineLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Domain"
                  variant="standard"
                  type="text"
                  name="industry_of_the_company"
                  sx={fieldStyle}
                  value={field.industry_of_the_company}
                  onChange={(event) => handleInputChange(index, event)}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiMapPinSimpleLineLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Duration From"
                  variant="standard"
                  type="text"
                  name="duration_from"
                  sx={fieldStyle}
                  value={field.duration_from}
                  onChange={(event) => handleInputChange(index, event)}
                />
              </Grid>
              {index !== 0 && (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                >
                  <Box className={styles.icon_style}>
                    <PiMapPinSimpleLineLight style={{ fontSize: "25px" }} />
                  </Box>
                  <TextField
                    id="standard-basic"
                    label="Duration To"
                    variant="standard"
                    type="text"
                    name="duration_to"
                    sx={fieldStyle}
                    value={field.duration_to}
                    onChange={(event) => handleInputChange(index, event)}
                  />
                </Grid>
              )}
            </Grid>

            <Box className={styles.add_section}>
              <Box>
                <Typography>
                  <b> Responsibilities</b>{" "}
                </Typography>

                <Typography sx={{ marginBottom: "0 !important" }}>
                  <textarea
                    className="form-control"
                    rows="2"
                    name="summary_of_work"
                    data-key="summary_of_work"
                    value={field.summary_of_work}
                    onChange={(event) => {
                      handleInputChange(index, event);
                      autoResize(event.target);
                    }}
                    onInput={(event) => autoResize(event.target)}
                    style={{
                      width: "100%", // Make it take full width of the parent container
                      borderColor: "#1991e0",
                      overflow: "hidden",
                      resize: "none", // Prevent manual resizing
                    }}
                    ref={(el) => el && autoResize(el)} // Auto-resize on initial render
                  ></textarea>
                  {formFields?.length - 1 === index && (
                    <Link
                      className={styles.view_show_link}
                      onClick={handleToggle}
                    >
                      <IoIosAdd
                        onClick={handleAddFields}
                        style={{
                          marginTop: "10px",
                          fontSize: "30px",
                          color: "#000",
                          backgroundColor: "#f2f2f2",
                          borderRadius: "3px",
                          marginLeft: "20px",
                        }}
                      />
                    </Link>
                  )}
                </Typography>
              </Box>
            </Box>

            <Grid
              item
              xs={12}
              md={0.6}
              sx={{
                display: "flex",
                alignItems: "center",
                paddingTop: "0 !important",
              }}
            ></Grid>
          </form>
        ))}

        <Box className={styles.add_candidate_btns}>
          <Box className={styles.add_back_btns}>
            <button
              onClick={() => {
                setMenuName("Persional Details");
                setMenuId(1);
              }}
              style={{
                border: "1.5px solid #4285f4",
                marginRight: "10px",
                padding: "4.5px 10px ",
              }}
            >
              <IoIosArrowRoundBack
                style={{ fontSize: "25px", color: "#4285f4" }}
              />
            </button>
          </Box>
          <button
            // onClick={() => navigate("/internal-tracker-submit")}
            // onClick={handleManageClickOpen}
            onClick={formik.handleSubmit}
            style={{
              backgroundColor: "#3856a6 ",
              padding: "5.5px 5px 5.5px 10px ",
            }}
          >
            Skip & Next{" "}
            <IoIosArrowRoundForward
              style={{ fontSize: "25px", marginLeft: "5px" }}
            />
          </button>
        </Box>
      </Box>
      <Dialog
        fullScreen={fullScreen}
        open={openManage}
        onClose={handleManageClose}
        aria-labelledby="responsive-dialog-title"
        maxWidth="md"
        fullWidth={true}
      >
        <DialogContent sx={{ padding: "0 20px" }}>
          <Box className={styles.recruiter_matches}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <b style={{ fontSize: "80px ", marginRight: "20px" }}> 1</b>

              <Box>
                <Typography>
                  Filed can impact on your filter during the filtration{" "}
                  <Typography>So fill all filed carefully.</Typography>
                </Typography>
                <Typography>Nothing to worry complete it latter.</Typography>
              </Box>
            </Box>
            <img src={profile} alt="" />
          </Box>

          <Box className={styles.complete_btn}>
            <Box className={styles.complete_add_btns}>
              <button
                style={{
                  marginRight: "10px",
                  backgroundColor: "#4287f5 ",
                  padding: "7.5px 10px ",
                }}
                onClick={handleManageClose}
              >
                Complete
              </button>
            </Box>

            <button
              style={{ backgroundColor: "#3856a6 ", padding: "7.5px 10px " }}
              onClick={formik.handleSubmit}
            >
              Do it Later
            </button>
          </Box>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
    // </RootComponents>
  );
};

export default AddConsultantResume;
